import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import Cookies from 'js-cookie';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import ItemInquiry from './ItemInquiry.js';
import Footer from '../Footer.js';
import { GetDomain, RemoveCookie, GetCoockie, ValidateQty, days, shopping_cart_session_days, shopping_cart_session_id, user_session_id } from "../GlobalScript";
import CloseButton from 'react-bootstrap/CloseButton';
import useLocalStorage from "use-local-storage";
import OrderSessionPopup from './OrderSessionPopup.js';
export default function KCountriesHome() {

    const navigate = useNavigate();
    const [UserInfo, setUserInfo] = useState(null);
    /*const [Loading, setLoading] = useState(true);*/
    const [itemNum, setItemNum] = useState('');
    const [quantity, setQuantity] = useState('');
    const [ItemsToitemInquiry, setItemsToitemInquiry] = useState([]);
/*    const [selectedItems, setSelectedItems] = useState([]);*/
    const [showItemModal, setShowItemModal] = useState(false);
    const [shoppingCart, setShoppingCart] = useState(null);
    const [showCartModal, setShowCartModal] = useState(false);
    const [ShoppingCartSession, setShoppingCartSession] = useLocalStorage(shopping_cart_session_id, "");
    const handleItemModalShow = () => {
        const crrMap = new Map();
        const sc = ShoppingCartSession;
        if (sc) {
            sc.forEach(element => {
                crrMap.set(element.item.distitemNbr, { itemNum: element.item.distitemNbr, quantity: element.item.qty });
            });
        }
        const qty = ValidateQty(quantity);
        if (itemNum !== '' && qty !== '') {
            crrMap.set(itemNum, { itemNum: itemNum, quantity: qty });
        }
        setItemsToitemInquiry(Array.from(crrMap.values()));
        setShowItemModal(true);

    }
    const handleOrderClicked = async () => {
        if (shoppingCart) {
            handleShowCartOpen();
        } else {
            navigate("/neworder");
        }
    }
    const handleShowCartClose = () => setShowCartModal(false);
    const handleShowCartOpen = () => setShowCartModal(true);
    const handleItemModalClose = () => setShowItemModal(false);

    const handleSelectedItems = (items) => {
        setShoppingCartSession(items);
        navigate('/neworder');
    };
    
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'itemNum') {
            setItemNum(value);
        } else if (name === 'quantity') {
            let newQty = ValidateQty(value);
            setQuantity(newQty);
            console.log(quantity);
        }
    }

    //const days = 8 / 24;

    useEffect(() => {
        debugger;
        let ck = GetCoockie();
        console.log(ck);
        if (ck) {
            setUserInfo(ck);
            window.GlobalLoading++;
            if (window.GlobalLoading === 1) {

                window.location.reload();
            }

        }
        
    }, [GetCoockie])

    const LogoutDealerClick = () => {
        RemoveCookie(days, user_session_id);
        window.location.href = '/login';
        setUserInfo(null);
    }

    return (
        <>
            {UserInfo ?
                <>
                    <Container className="checkout-container main-container dealer-section">

                        <Row className="help-title-row checkout-title-row">
                            <Col className="help-center-title checkout-title">
                                <h1 className="heading help-heading">PARTS & ACCESSORIES</h1>
                            </Col>
                            <Col className="checkout-title-under">
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={2}></Col>
                            <Col sm={4}>
                                <Card className="black-bg">
                                    <Card.Body>
                                        <Row>
                                            <Col sm={8} className="mb-4">
                                                <div className="svg-row dealer-card">
                                                    <div className="svg-holder">
                                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36.7 36.3" style={{ marginRight: 7 }}>
                                                            <g>
                                                                <path className="green" d="M10,1.2c-.9,0-1.6.7-1.6,1.6v24.5c0,.9.7,1.6,1.6,1.6h24.5c.9,0,1.6-.7,1.6-1.6V2.9c0-.9-.7-1.6-1.6-1.6H10ZM32.9,25.7H11.6V4.5h21.2v21.2Z" />
                                                                <path className="green" d="M15.4,16.7h5.2v5.2c0,.9.7,1.6,1.6,1.6.9,0,1.6-.7,1.6-1.6v-5.2h5.2c.9,0,1.6-.7,1.7-1.6s-.7-1.6-1.6-1.7c0,0,0,0,0,0h-5.2v-5.2c0-.9-.8-1.6-1.7-1.6-.9,0-1.6.7-1.6,1.6v5.2h-5.2c-.9,0-1.6.8-1.6,1.7,0,.9.7,1.6,1.6,1.6h0Z" />
                                                                <path className="green" d="M2.4,35.7h26.3c.9,0,1.6-.8,1.6-1.7,0-.9-.7-1.6-1.6-1.6H4.1V8.4c0-.9-.8-1.6-1.7-1.6-.9,0-1.6.7-1.6,1.6v25.7c0,.9.7,1.6,1.6,1.6Z" />
                                                            </g>
                                                        </svg>
                                                    </div>

                                                    <h5 className="green-text mb-0">ITEM INQUIRY</h5>
                                                </div>
                                            </Col>
                                            <Col sm={4} className="mb-4">
                                                <p className="white underline text-right mb-0" onClick={handleItemModalShow}>Go to Form</p>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={9}>
                                                <FloatingLabel label="Item Number" className="mb-4">
                                                    <Form.Control id="controlItemNum" type="text" placeholder="Item Number" value={itemNum} className={'form-control'} onChange={handleChange} name="itemNum" />
                                                </FloatingLabel>
                                            </Col>
                                            <Col sm={3}>
                                                <FloatingLabel label="Qty" className="mb-4">
                                                    <Form.Control id="controlQty" type="text" placeholder="Qty" value={quantity} className={'form-control'} onChange={handleChange} name="quantity" />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={{ offset: 8 }} className="text-right mb-1">
                                                <Button variant="primary" className="" onClick={handleItemModalShow} disabled={ !itemNum || !quantity ? true : false }>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    SUBMIT
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={4}>
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col sm={8} className="mb-1">
                                                <div className="svg-row dealer-card">
                                                    <div className="svg-holder">
                                                        <svg version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="15px" y="15px" viewBox="0 0 50 50" xmlSpace="preserve">
                                                            <g stroke="none" strokeWidth="1">
                                                                <polygon className="st3" points="13.19,3.53 13.19,8.96 7.48,8.96 "></polygon>
                                                                <path className="st4" d="M-66.52,44.61"></path>
                                                                <path className="st3" d="M40.45,1.75H17.29c-0.82,0-1.48,0.66-1.48,1.48v6.77c0,0.82-0.66,1.48-1.48,1.48H7.46 
                                                                c-0.82,0-1.48,0.66-1.48,1.48v32.49c0,0.82,0.66,1.48,1.48,1.48h32.99c0.82,0,1.48-0.66,1.48-1.48V3.24 
                                                                C41.94,2.42,41.27,1.75,40.45,1.75z M18.17,38.88h-8c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h8 
                                                                c0.64,0,1.15,0.52,1.15,1.15C19.33,38.37,18.81,38.88,18.17,38.88z M26.34,30.47c0,0.64-0.52,1.15-1.15,1.15H10.18 
                                                                c-0.64,0-1.15-0.52-1.15-1.15v0c0-0.64,0.52-1.15,1.15-1.15h15.01C25.82,29.32,26.34,29.83,26.34,30.47L26.34,30.47z M37.58,24.37 
                                                                H10.18c-0.64,0-1.15-0.52-1.15-1.15s0.52-1.15,1.15-1.15h27.41c0.64,0,1.15,0.52,1.15,1.15S38.22,24.37,37.58,24.37z M37.58,17.11 
                                                                H10.18c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h27.41c0.64,0,1.15,0.52,1.15,1.15 
                                                                C38.74,16.59,38.22,17.11,37.58,17.11z M37.58,9.85h-17.5c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h17.5 
                                                                c0.64,0,1.15,0.52,1.15,1.15C38.74,9.33,38.22,9.85,37.58,9.85z"></path>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <h5 className="mb-0">ORDERING</h5>
                                                </div>
                                            </Col>
                                            <Col sm={4} className="mb-4">
                                                <p className="underline text-right mb-0" onClick={() => navigate("/orderhistory")}>Order History</p>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={12}>
                                                <Table bordered>
                                                    <tbody>
                                                        <tr>
                                                            <td>Open Orders</td>
                                                            <td className="text-center">5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Backorders</td>
                                                            <td className="red text-center">2</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={{ offset: 6 }} className="text-right mb-1">
                                                <Button variant="primary" className="" onClick={handleOrderClicked}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    NEW / IMPORT ORDER
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mt-5">

                            <Col sm={{ span: 8, offset: 2 }}>
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col sm={12} className="mb-4">
                                                <div className="svg-row dealer-card">
                                                    <div className="svg-holder">
                                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 40.7 37.8" style={{ marginRight: 7 }}>
                                                            <defs>                                                         
                                                                <clipPath id="clippath">
                                                                    <rect className="st0" y="-2.6" width="50.3" height="39.7" />
                                                                </clipPath>
                                                            </defs>
                                                            <g className="st3">
                                                                <g>
                                                                    <path className="st1" d="M8.7,8.9h30.7s0,16.5-6.5,16c-4.9.3-21.1,1.5-21.1,1.5,1.8,2.3,1.3,1.9,20,1.6,1.2.1.9,1.6-.2,1.3-3.9,0-17.3,0-17.3,0-3,0-3.4-1.4-3.9-3.3-.7-4.2-3.4-18.5-3.4-18.5-.4-1.5-2-2.4-3.5-1.9,0,0-.1,0-.2,0-1.9,2.6-4-3,0-1.6,3.7.2,3.9.8,5.6,4.8Z" />
                                                                    <path className="st1" d="M17.4,34.5c0,1.4-1.2,2.6-2.7,2.6-1.4,0-2.6-1.2-2.6-2.7,0-1.4,1.2-2.6,2.6-2.6,1.5,0,2.6,1.2,2.6,2.7h0" />
                                                                    <path className="st1" d="M32.2,34.3c0,1.4-1.2,2.6-2.7,2.6-1.4,0-2.6-1.2-2.6-2.7,0-1.4,1.2-2.6,2.6-2.6,1.5,0,2.6,1.2,2.6,2.7,0,0,0,0,0,0" />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </div>

                                                    <h5 className="mb-0">SHOP</h5>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={3}>
                                                <Card className="product-card">
                                                    <div className="green-border-bottom card-img-holder">
                                                        <img src="../../../Images/motorcycle.png" alt="Motorcycle" className="" />
                                                    </div>
                                                    <Card.Body>
                                                        <Row>
                                                            <Col sm={12} className="text-center">
                                                                <h5>MOTORCYCLE</h5>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col sm={3}>
                                                <Card className="product-card">
                                                    <div className="green-border-bottom card-img-holder">
                                                        <img src="../../../Images/atv.png" alt="ATV" className="" />
                                                    </div>
                                                    <Card.Body>
                                                        <Row>
                                                            <Col sm={12} className="text-center">
                                                                <h5>ATV</h5>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col sm={3}>
                                                <Card className="product-card">
                                                    <div className="green-border-bottom card-img-holder">
                                                        <img src="../../../Images/sidexside.png" alt="Side X Side" className="" />
                                                    </div>
                                                    <Card.Body>
                                                        <Row>
                                                            <Col sm={12} className="text-center">
                                                                <h5>SIDE X SIDE</h5>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col sm={3}>
                                                <Card className="product-card">
                                                    <div className="green-border-bottom card-img-holder">
                                                        <img src="../../../Images/jet-ski.png" alt="Jet Ski" className="" />
                                                    </div>
                                                    <Card.Body>
                                                        <Row>
                                                            <Col sm={12} className="text-center">
                                                                <h5>JET SKI</h5>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>

                                        <Row className="mt-4">
                                            <Col sm={{ offset: 6 }} className="text-right mb-3">
                                                <Button variant="primary" className="">
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    SHOP ALL
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="m-t-md" style={{visibility: 'hidden'}}>
                            <Col className="">{UserInfo.firstName} {UserInfo.lastName} {UserInfo.email}</Col>
                            <Col className="checkout-title" onClick={LogoutDealerClick}>
                                <Card.Title className="heading card-main-title active-heading clickable" role="heading">Log Out</Card.Title>
                            </Col>
                        </Row>

                    </Container>
                    <Footer />
                    {/*< <Modal show={showCartModal} onHide={handleShowCartClose} dialogClassName="dealer-section" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>EXISTING ORDER</Modal.Title>
                            <CloseButton variant="white" data-bs-theme="dark" />
                        </Modal.Header>

                        <Modal.Body>
                            <Row>
                                <Col sm={12}>
                                    <p>There is an order in progress. Do you want to resume that order or start a new order?</p>
                                </Col>
                            </Row>
                        </Modal.Body>

                        <Modal.Footer className="text-center">
                            <Button variant="secondary" onClick={() => navigate("/neworder")}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                RESUME ORDER
                            </Button>
                            <Button variant="primary" onClick={() => { localStorage.clear(); navigate("/neworder"); window.location.reload(); }}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                NEW ORDER
                            </Button>
                        </Modal.Footer>
                    </Modal>*/}
                </>
                  
            :
                <></> 
            }    
            <Container className="">
                <Row>
                </Row>
            </Container>
            <ItemInquiry show={showItemModal} handleClose={handleItemModalClose} handleSelectedItems={handleSelectedItems} initialValues={ItemsToitemInquiry} orderType={1} autoSubmit={true} />
            <OrderSessionPopup show={showCartModal} handleShowCartClose={handleShowCartClose}></OrderSessionPopup>
        </>
    );
}